import BussinessProcessEventsForm from './BussinessProcessEventsForm.vue'
import { axiosPost } from '../../../axios/axios.js'

export const businessProcessEventsHistory = {
  data: function () {
    return {
      rows: [],
      openedEdit: false
    }
  },
  created: function () {
    if (typeof this.record === 'undefined') {
      throw new Error('Необходимо определить record в использующем mixin компоненте')
    }
  },
  methods: {
    // @Default
    isMobile () {
      return false
    },
    getExtendedEventName: function (row) {
      if (row.extendedName) {
        return row.extendedName
      }
      return this.getEventName(row)
    },
    getEventName: function (row) {
      if (row.name) {
        return row.name
      }

      // if (row.phase === 'in') {
      //   prefix = 'Переход в '
      // } else
      if (row.phase === 'in' || row.phase === 'other') {
        return row.stateAlias
      } else {
        let prefix
        if (row.phase === 'out') {
          prefix = 'Выход из '
        } else {
          prefix = ''
        }
        return prefix + '"' + row.stateAlias + '"'
      }
    },
    onOpen: function (event) {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        // TODO maximized: mobile && config.props && config.props.length !== 0
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: BussinessProcessEventsForm,
        contentProps: {
          record: this.record,
          mobile: this.isMobile(),
          initConfig: {
            callback: forms => {
              const formContent = forms[event.form.type]
              return this.saveEdit(event, formContent).then(() => {
                this.$emit('update')

                this.$nextTick(() => {
                  dialog.hide()
                })
              })
            },
            event: event,
            forms: [event.form],
            btnOkName: 'Сохранить',
            title: this.getEventName(event),
            edit: true,
            readonly: event.readonly
          }
        },
        componentHandlers: {
          save: (saveData) => {
            dialog.hide()
          },
          close: () => {
            dialog.hide()
            this.$emit('close')
          }
        }
      })
    },
    onDelete: function (event) {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        // TODO maximized: mobile && config.props && config.props.length !== 0
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: BussinessProcessEventsForm,
        contentProps: {
          record: this.record,
          mobile: this.isMobile(),
          initConfig: {
            callback: () => {
              return this.deleteEvent(event).then(() => {
                dialog.hide()

                this.$emit('update')
              })
            },
            event: event,
            forms: [event.form],
            btnOkName: 'Удалить',
            title: this.getEventName(event),
            delete: true
          }
        },
        componentHandlers: {
          save: (saveData) => {
            // TODO ???
            // dialog.hide()
          },
          close: () => {
            dialog.hide()
            this.$emit('close')
          }
        }
      })
    },
    saveEdit: function (event, formContent) {
      this.$q.loading.show({
        spinnerColor: 'blue-11'
      })

      const bodyFormData = new FormData()
      bodyFormData.set('objectId', this.record.bp.id)
      bodyFormData.set('eventId', event.id)
      bodyFormData.set('formContent', JSON.stringify(formContent))

      const eventService = event.eventService
      return axiosPost({
        url: `/service/delta/${eventService}/editEvent`,
        data: bodyFormData,
        onSuccess: (response) => {
          const eventUpdated = response.data.result
          const index = this.record.bp.events.findIndex(eventItem => eventItem === event)
          this.record.bp.events.splice(index, 1, eventUpdated)

          this.$q.notify({
            type: 'positive',
            message: 'Изменения успешно сохранены',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
          return Promise.reject(new Error(response.message))
        },
        throws: true
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    deleteEvent: function (event) {
      this.$q.loading.show({
        spinnerColor: 'blue-11'
      })

      const bodyFormData = new FormData()
      bodyFormData.set('objectId', this.record.bp.id)
      bodyFormData.set('eventId', event.id)

      const eventService = event.eventService
      return axiosPost({
        url: `/service/delta/${eventService}/deleteEvent`,
        data: bodyFormData,
        onSuccess: (response) => {
          const index = this.record.bp.events.findIndex(eventItem => eventItem === event)
          this.record.bp.events.splice(index, 1)

          this.$q.notify({
            type: 'positive',
            message: 'Изменения успешно сохранены',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
          return Promise.reject(new Error(response.message))
        },
        throws: true
      }).finally(() => {
        this.$q.loading.hide()
      })
    }
  }
}
